// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"CarFeatureList-mobile__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CarHire/CarFeatureList.mobile.scss
 ** module id = 895
 ** module chunks = 1
 **/